import React, {Component} from 'react'
import PropTypes from 'prop-types'

import ExportComponent from './Export.component'

class ExportContainer extends Component {
    static propTypes = {
      onClose: PropTypes.func,
      api: PropTypes.object,
      download: PropTypes.object
    }

    constructor(props) {
      super(props)

      const formats = props.download.formats.slice()

      formats.forEach((format, i) => {
        format.checked = (i === 0)
      })

      this.state = {
        formats,
        contentFilterChecked: true,
        showDownloadConfirmationLimit: false
      }
    }

    handleFormatChange = ({ target: { value } }) => { 
      if (this.props.api.getFiltersAsList().length > 0 && value === 'content_filter1') {
        this.setState({
          contentFilterChecked: true
        })
      } else if (this.props.api.getFiltersAsList().length > 0 && value === 'content_filter2') {
        this.setState({
          contentFilterChecked: false
        })
      }
      if (value !== 'content_filter1' && value !== 'content_filter2') {
        const formats = this.state.formats

        formats.forEach((format, i) => {
          format.checked = (format.name === value)
        })
        this.setState({
          formats
        })
      }

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Download Format Change',
        type: 'Datatable'
      })
    }

    /**
     * Initiates the download
     * (called from the download button "Apply" directly)
     */
    handleApplyDownload = (evt) => {
      let rowstodownload = this.props.api.dataset

      const length = (() => {
        let output = (rowstodownload && rowstodownload.length) ? rowstodownload.length : 0

        if (!this.props.multiselect || (this.props.multiselect && !this.props.multiselect.enabled)) {
          if (this.props.api.sortEngine === 'server') {
            output = this.props.api.getTotalItems()
          }
        }

        if(this.props.api.sortEngine !== 'server' && (this.props.api.getFiltersAsList().length > 0 || this.props.api.getSearch())) {
          output = this.props.api.getTotalItems();
        }

        return output
      })()

      if (this.state.contentFilterChecked) {
        rowstodownload = this.props.api.getFilteredItems()
      }

      const exportLimit = this.props.download.exportLimit || 15000

      if (rowstodownload !== null) {
        if (this.props.env.checkFunction(this.props.download.formats[0].callback) && length <= exportLimit) {
          let rowsFormat = 'CSV'

          this.state.formats.forEach((format, i) => {
            rowsFormat = format.checked === true ? format.name : 'CSV'
          })
          evt.preventDefault()

          const filterPayload = {
            pagination: this.props.api.getPagination(),
            filters: this.props.api.getFilters(),
            sort: this.props.api.getSort(),
            search: this.props.api.getSearch()
          }

          this.props.analytics.downloadClick({
            text: this.props.title,
            type: 'Download',
            filename: 'Datatable export',
            filetype: rowsFormat
          })

          this.props.env.callFunction(
            this.props.download.formats[0].callback, 
            [rowstodownload, rowsFormat, filterPayload, this.props.api.allRowsSelected]
          )
          this.props.onClose()
        } else if (length > exportLimit) {
          this.setState({
            showDownloadConfirmationLimit: true
          })
        }
      } else {
        this.props.onClose()
      }

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Apply Download',
        type: 'Datatable'
      })
    }

    /**
     * Initiates the download
     * (called when confirming the prompt about exceeding the limit)
     */
    handleDownload = (evt) => {
      let rowstodownload = this.props.api.dataset
      let rowsFormat = 'CSV'

      if (this.props.api.getFilteredItems().length > 0 && this.state.contentFilterChecked) {
        rowstodownload = this.props.api.getFilteredItems()
      }

      this.state.formats.forEach((format, i) => {
        rowsFormat = format.checked === true ? format.name : 'CSV'
      })

      if (this.props.env.checkFunction(this.props.download.formats[0].callback)) {
        evt.preventDefault()

        const filterPayload = {
          pagination: this.props.api.getPagination(),
          filters: this.props.api.getFilters(),
          sort: this.props.api.getSort(),
          search: this.props.api.getSearch()
        }

        this.props.env.callFunction(
          this.props.download.formats[0].callback, 
          [rowstodownload, rowsFormat, filterPayload, this.props.api.allRowsSelected]
        )
      }

      this.props.analytics.downloadClick({
        text: this.props.title,
        type: 'Download',
        filename: 'Datatable export',
        filetype: rowsFormat
      })

      this.props.onClose()

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Handle Download',
        type: 'Datatable',
        payloadSize: rowstodownload.length || 0
      })
    }

    handleClose = (evt) => {
      evt.preventDefault()

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Close Download Dialog',
        type: 'Datatable'
      })

      this.props.onClose()
    }

    getDescription() {
      const items = this.props.api.getFilteredItems()

      return (items && items.length === 1) ? 'Item' : 'Items'
    }

    render() {
      const {i18n} = this.props
      const {formats} = this.state
      const filters = this.props.api.getFiltersAsList()
      const events = {
        handleApplyDownload: this.handleApplyDownload,
        handleClose: this.handleClose,
        handleFormatChange: this.handleFormatChange,
        handleDownload: this.handleDownload
      }

      return (
        <ExportComponent
          description={this.getDescription()}
          events={events}
          filters={filters}
          formats={formats}
          filteredSize={this.props.api.getFilteredItems()}
          i18n={i18n}
          contentFilterChecked={this.state.contentFilterChecked}
          showDownloadConfirmationLimit={this.state.showDownloadConfirmationLimit}
          exportLimit={this.props.download.exportLimit || 15000}
          sortEngine={this.props.api.sortEngine}
        />
      )
    }
}

export default ExportContainer
